import { metadataTypes } from './types';
export const REF_PROPERTY = '@ref';
export const REF_PROPERTY_SHORTCUT = `${REF_PROPERTY}:`;
export const refTypeMap = {
  actions: metadataTypes.ACTION,
  elements: metadataTypes.ELEMENT,
  containers: metadataTypes.CONTAINER,
  fields: metadataTypes.FIELD,
  iterables: metadataTypes.ITERABLE,
  layouts: metadataTypes.LAYOUT,
  component: metadataTypes.COMPONENT
};